// extracted by mini-css-extract-plugin
export default {"ChecksStatusBadgeButton":"ChecksStatusBadge-module__ChecksStatusBadgeButton--cXKro","ChecksStatusBadgeIconButton":"ChecksStatusBadge-module__ChecksStatusBadgeIconButton--XFKHo"};